<script setup lang="ts">
import type { ISvgIllustrationProps } from '@/types/components/SvgIllustration/SvgIllustration';
import { defineAsyncComponent } from 'vue';

const props = defineProps<ISvgIllustrationProps>();

const SvgComponent = defineAsyncComponent({
  loader: () => import(`@/components/SvgIllustrations/Illustrations/${props.name}.vue`)
});
</script>

<template>
  <component :is="SvgComponent" :name="props.name" />
</template>
